import { colors, createTheme } from '@mui/material';
import { typography } from './typography';
import { palette } from './palette';
import { softShadows } from './shadows';

export const theme = createTheme({
  direction: 'ltr',
  typography,
  components: {
    MuiAlert: {
      styleOverrides: {
        filledError: {
          backgroundColor: '#d84847',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: 14,
          fontWeight: 400,
          color: '#797979',
          textTransform: 'capitalize',
        },
        containedPrimary: {
          backgroundColor: '#6692CD',
          borderRadius: 2,
          color: '#fff',
          fontSize: 14,
          fontWeight: 700,
          height: 38,
          margin: '5px 5px 5px 0',
          minWidth: 85,
          textAlign: 'center',
          '&:hover': {
            backgroundColor: '#335f9a',
          },
          '&:disabled': {
            background: '#D0D0CC;',
          },
        },
        containedSecondary: {
          borderRadius: 2,
          fontSize: 14,
          fontWeight: 700,
          height: 38,
          minWidth: 85,
          textAlign: 'center',
        },
        outlinedPrimary: {
          fontWeight: 500,
        },
        outlinedSecondary: {
          borderColor: '#D0D0CC',
          borderRadius: 2,
          fontWeight: 500,
          height: 39,
          minWidth: 87,
          textAlign: 'center',
        },
        textSecondary: {
          color: '#797979',
          fontSize: 14,
        },
        containedSizeSmall: {
          fontSize: 14,
        },
        containedSizeLarge: {
          fontSize: 14,
        },
      },
    },
    MuiDialog: {
      defaultProps: {
        fullWidth: true,
        scroll: 'paper',
      },
    },
    MuiFilledInput: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiFormControl: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiFormHelperText: {
      defaultProps: {
        margin: 'dense',
      },
      styleOverrides: {
        root: {
          '&.Mui-error': {
            color: '#cd4747',
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          '&.Mui-error': {
            color: '#cd4747',
          },
        },
        asterisk: {
          color: '#E2760A',
          '&.Mui-error': {
            color: '#E2760A',
          },
        },
      },
    },
    MuiInputBase: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {
        input: {
          '&::placeholder': {
            opacity: 1,
            color: colors.blueGrey[600],
          },
        },
      },
    },
    MuiInputLabel: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiLinearProgress: {
      //helps prevent the animation from freezing.
      styleOverrides: {
        bar: {
          transition: 'none',
        },
      },
    },
    MuiOutlinedInput: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {
        root: {
          '&.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: '#cd4747',
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: 16,
          textTransform: 'inherit',
          '&.Mui-selected': {
            color: '#00134E',
            fontWeight: 'bold',
          },
        },
        textColorSecondary: {
          color: '#797979',
          '&.Mui-selected': {
            color: '#00134E',
            fontWeight: 'bold',
          },
        },
        selected: {},
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: '#00134E',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiToolbar: {
      defaultProps: {
        variant: 'dense',
      },
    },
  },
  palette,
  shadows: softShadows,
  spacing: 1,
  transitions: {
    duration: {
      enteringScreen: 375, // MUI default * 5/3
      leavingScreen: 325, // MUI default * 5/3
    },
  },
});
